var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.id)?_c('iframe',{class:{ 'h-full w-full object-cover': _vm.containerSize },attrs:{"width":"100%","height":"100%","src":`https://www.youtube.com/embed/${_vm.id}?autoplay=${Number(
    _vm.autoplay,
  )}&mute=1`,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;","allowfullscreen":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }